import React, { lazy, Suspense } from 'react';
import { LoadingSpinner } from '@miroculus/miroculus-ui';
const OrganizationSettings = lazy(() => import(
/* webpackChunkName: 'organization-settings' */
'./OrganizationSettings'));
const loading = React.createElement(LoadingSpinner, { message: "Loading settings..." });
const OrganizationSettingsLoader = (props) => (React.createElement(Suspense, { fallback: loading },
    React.createElement(OrganizationSettings, { ...props })));
export default OrganizationSettingsLoader;
